var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 182,
    viewBox: "0 0 199 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_22_4108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.69715 108.184C-1.46155 97.4935 -1.46155 84.3327 4.69715 73.6425L37.1414 17.3264C43.3174 6.60635 54.7476 3.11695e-05 67.1193 3.1317e-05L131.879 3.20893e-05C144.251 3.22368e-05 155.681 6.60636 161.857 17.3264L194.301 73.6425C200.46 84.3327 200.46 97.4935 194.301 108.184L161.857 164.5C155.681 175.22 144.251 181.826 131.879 181.826L67.1193 181.826C54.7476 181.826 43.3174 175.22 37.1414 164.5L4.69715 108.184Z",
    fill: "url(#paint0_linear_22_4108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99689 107.435C0.105208 97.2082 0.105205 84.618 5.99688 74.3913L38.4412 18.0752C44.3493 7.81993 55.2839 1.50003 67.1193 1.50003L131.879 1.50003C143.715 1.50003 154.649 7.81993 160.557 18.0752L193.002 74.3913C198.893 84.618 198.893 97.2082 193.002 107.435L160.557 163.751C154.649 174.006 143.715 180.326 131.879 180.326L67.1193 180.326C55.2839 180.326 44.3493 174.006 38.4412 163.751L5.99689 107.435Z",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_22_4108",
    x: -16.3884,
    y: -16.4666,
    width: 231.775,
    height: 214.759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.23328
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_22_4108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_22_4108",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53332
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26666
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_22_4108"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.5332
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_22_4108",
    result: "effect3_innerShadow_22_4108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_4108",
    x1: 0.0781261,
    y1: 90.9131,
    x2: 198.92,
    y2: 90.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonLarge);
export default __webpack_public_path__ + "static/media/hexagon-large.78532d24baa0fad88f35f6192244cd23.svg";
export { ForwardRef as ReactComponent };